import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rat-loader',
  templateUrl: './rat-loader.component.html',
  styleUrls: ['./rat-loader.component.css']
})
export class RatLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    // console.log("In Loader..")
  }

}
